(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nami-campaign-hero"] && !Shopify.designMode) return;
  try {
    
  class NamiVideoHero extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggleButton = this.querySelector('[data-video-toggle]');
      this.scrollButton = this.querySelector('[data-scroll-next]');

      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      this.scrollButton?.addEventListener('click', () => this.scrollToNextSection(), { signal });

      if (!this.video || !this.toggleButton) return;

      this.toggleButton.addEventListener('click', () => this.togglePlayback(), { signal });
      this.video.addEventListener('play', () => this.updateControl(true), { signal });
      this.video.addEventListener('pause', () => this.updateControl(false), { signal });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.video.pause();
        this.video.removeAttribute('autoplay');
        this.updateControl(false);
        return;
      }

      const playPromise = this.video.play();
      if (playPromise) {
        playPromise.catch(() => this.updateControl(false));
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    togglePlayback() {
      if (this.video.paused) {
        const playPromise = this.video.play();
        if (playPromise) {
          playPromise.catch(() => this.updateControl(false));
        }
      } else {
        this.video.pause();
      }
    }

    updateControl(isPlaying) {
      const playIcon = this.toggleButton.querySelector('[data-video-play-icon]');
      const pauseIcon = this.toggleButton.querySelector('[data-video-pause-icon]');
      const toggleLabel = this.toggleButton.querySelector('[data-video-toggle-label]');
      const nextLabel = isPlaying ? this.toggleButton.dataset.pauseLabel : this.toggleButton.dataset.playLabel;

      playIcon.hidden = isPlaying;
      pauseIcon.hidden = !isPlaying;
      this.toggleButton.setAttribute('aria-label', nextLabel);

      if (toggleLabel) {
        toggleLabel.textContent = nextLabel;
      }
    }

    scrollToNextSection() {
      const sectionWrapper = this.closest('.shopify-section');
      const nextSection = sectionWrapper?.nextElementSibling;

      if (nextSection instanceof HTMLElement) {
        nextSection.scrollIntoView({ block: 'start' });
      }
    }
  }

  if (!customElements.get('nami-video-hero')) {
    customElements.define('nami-video-hero', NamiVideoHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  const setupNamiGalleries = (root = document) => {
    root.querySelectorAll('[data-nami-gallery]').forEach((gallery) => {
      if (gallery.dataset.namiReady) return;
      gallery.dataset.namiReady = 'true';

      const media = [...gallery.querySelectorAll('.media-gallery__grid > li')];
      const thumbs = [...gallery.querySelectorAll('[data-nami-thumb]')];
      if (!media.length || !thumbs.length) return;

      const setActive = (index) => {
        thumbs.forEach((thumb, thumbIndex) => {
          thumb.setAttribute('aria-current', thumbIndex === index ? 'true' : 'false');
        });
      };

      const observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting);
        if (!visible.length) return;
        visible.sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        setActive(media.indexOf(visible[0].target));
      }, {
        rootMargin: '-20% 0px -35% 0px',
        threshold: [0, 0.25, 0.5, 0.75, 1]
      });

      media.forEach((item) => observer.observe(item));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupNamiGalleries(), { once: true });
  } else {
    setupNamiGalleries();
  }

  document.addEventListener('shopify:section:load', (event) => setupNamiGalleries(event.target));

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const thumb = event.target.closest('[data-nami-thumb]');
    if (thumb) {
      const gallery = thumb.closest('[data-nami-gallery]');
      const media = gallery?.querySelectorAll('.media-gallery__grid > li')[Number(thumb.dataset.namiThumb)];
      gallery?.querySelectorAll('[data-nami-thumb]').forEach((item) => {
        item.setAttribute('aria-current', item === thumb ? 'true' : 'false');
      });
      media?.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
      return;
    }

    const trigger = event.target.closest('[data-nami-panel-open]');
    if (trigger) {
      const panel = trigger.getAttribute('data-nami-panel-open');
      const dialog = trigger.closest('.shopify-section')?.querySelector(`[data-nami-panel="${panel}"]`);
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    const close = event.target.closest('[data-nami-panel-close]');
    if (close) close.closest('dialog')?.close();
  });

  } catch(e) { console.error(e); }
})();
})();
